import { useSelector } from "react-redux"
import { ScreenState } from "../../../modules/screen/ScreenState"
import { MainState } from "../../../modules/state/MainState"

export const useScreen = (): ScreenState => useSelector((state: MainState) => state.screen)
